var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('Settings'),_c('Overall',{staticClass:"mb-3"}),_c('List'),_c('Detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }